import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

export function now() {
  return firebase.firestore.FieldValue.serverTimestamp();
}

export default firebase.initializeApp({
  apiKey: "AIzaSyCO1Ry501bEd_lyVs6JAt0VFN2jGsid4HU",
  databaseURL: "https://bf-testcases.firebaseio.com",
  storageBucket: "bf-testcases.appspot.com",
  authDomain: "bf-testcases.firebaseapp.com",
  messagingSenderId: "616465811637",
  projectId: "bf-testcases"
});

export const fbAuth = firebase.auth;
